import React, {useState, useEffect} from 'react';

import { storage } from '../../firebase';

import { updateAnswer, updateAnswerImage, deleteAnswer } from 'backend/Answer';

const AnswerItem = ({answer, index, subcategoryUid}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [isCorrect, setIsCorrect] = useState(answer.isCorrect);
  const [localIsCorrect, setLocalIsCorrect] = useState(answer.isCorrect);

  const [nameEn, setNameEn] = useState(answer.name.en);
  const [nameRu, setNameRu] = useState(answer.name.ru);
  const [nameUk, setNameUk] = useState(answer.name.uk);
  const [namePl, setNamePl] = useState(answer.name.pl);
  const [nameIt, setNameIt] = useState(answer.name.it);
  const [nameEs, setNameEs] = useState(answer.name.es);
  const [namePt, setNamePt] = useState(answer.name.pt);

  const [localNameEn, setLocalNameEn] = useState(answer.name.en);
  const [localNameRu, setLocalNameRu] = useState(answer.name.ru);
  const [localNameUk, setLocalNameUk] = useState(answer.name.uk);
  const [localNamePl, setLocalNamePl] = useState(answer.name.pl);
  const [localNameIt, setLocalNameIt] = useState(answer.name.it);
  const [localNameEs, setLocalNameEs] = useState(answer.name.es);
  const [localNamePt, setLocalNamePt] = useState(answer.name.pt);

  const [image, setImage] = useState(null);
  const [url, setUrl] = useState(answer.image);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setIsCorrect(answer.isCorrect);
    setLocalIsCorrect(answer.isCorrect);
    setNameEn(answer.name.en);
    setNameRu(answer.name.ru);
    setNameUk(answer.name.uk);
    setNamePl(answer.name.pl);
    setNameIt(answer.name.it);
    setNameEs(answer.name.es);
    setNamePt(answer.name.pt);

    setLocalNameEn(answer.name.en);
    setLocalNameRu(answer.name.ru);
    setLocalNameUk(answer.name.uk);
    setLocalNamePl(answer.name.pl);
    setLocalNameIt(answer.name.it);
    setLocalNameEs(answer.name.es);
    setLocalNamePt(answer.name.pt);

    setUrl(answer.image);
  }, [answer]);

  const handleChange = (e) => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      setImage(image);
    }
  };

  const handleUpload = (id) => {
    const uploadTask = storage.ref(`answer/${image.name}`).put(image);
    uploadTask.on(
      "state_changed",
      snapshot => {
        // progress function ...
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      error => {
        // Error function ...
        console.log(error);
      },
      () => {
        storage
          .ref("answer")
          .child(image.name)
          .getDownloadURL()
          .then((urlResult) => {
            //delete old image
            if (answer.image) {
              storage.refFromURL(answer.image).delete();
            }
            updateAnswerImage(id, urlResult);
            //update db
            setUrl(urlResult);
          });
      }
    );
  };

  const onClickDelete = (id) => {
    deleteAnswer(id)
      .then(() => {
        window.location.reload(false);
      })
      .catch((error) => {
        console.log('updateAnswer error', error);
      });
  };

  const onClickEdit = () => {
    setIsEdit(!isEdit);
  };

  const onClickSave = (id) => {
    setProgress(0);
    updateAnswer(
      id,
      isCorrect,
      subcategoryUid,
      nameEn,
      nameRu,
      nameUk,
      namePl,
      nameIt,
      nameEs,
      namePt)
      .then(() => {
        setIsEdit(false);
        setLocalIsCorrect(isCorrect);
        setLocalNameEn(nameEn);
        setLocalNameRu(nameRu);
        setLocalNameUk(nameUk);
        setLocalNamePl(namePl);
        setLocalNameIt(nameIt);
        setLocalNameEs(nameEs);
        setLocalNamePt(namePt);
      })
      .catch((error) => {
        console.log('updateAnswer error', error);
      });
  };

  const onClickCancel = () => {
    setIsEdit(false);
    setNameEn(localNameEn);
    setNameRu(localNameRu);
    setNameUk(localNameUk);
    setNamePl(localNamePl);
    setNameIt(localNameIt);
    setNameEs(localNameEs);
    setNamePt(localNamePt);
    setProgress(0);
  };

  const onChangeText = (event, field) => {
    if (field === 'nameEn') setNameEn(event.target.value);
    if (field === 'nameRu') setNameRu(event.target.value);
    if (field === 'nameUk') setNameUk(event.target.value);
    if (field === 'namePl') setNamePl(event.target.value);
    if (field === 'nameIt') setNameIt(event.target.value);
    if (field === 'nameEs') setNameEs(event.target.value);
    if (field === 'namePt') setNamePt(event.target.value);
  };

  const checkboxOnChange = (value) => {
    setIsCorrect(!isCorrect);
  };

	return (
		<tr style={{backgroundColor: isEdit ? '#EEF4F9' : ''}}>
      <td>{index + 1}</td>
      <td>
      {localIsCorrect && !isEdit ? (<span className="label label-success arrowed">Правильный</span>) : null}
        {isEdit ? (
          <label>
            <input name="switch-field-1" className="ace ace-switch" type="checkbox" value={true} onChange={(value) => checkboxOnChange(value)} checked={isCorrect}  />
            <span className="lbl" data-lbl="ДА        НЕТ"></span>
          </label>
        ) : null}
      </td>
      <td align="center">
        {url && !isEdit ? (<img src={url} alt={answer.id} width="100" />) : null}
        {isEdit ? (
          <div>
            <progress value={progress} max="100" className="progress" />
            <br />
            <label className="ace-file-input">
              <input type="file" id="id-input-file-2" onChange={(e) => handleChange(e)} />
              <span className="ace-file-container" data-title="Choose">
                <span className="ace-file-name" data-title="No File ...">
                  <i className=" ace-icon fa fa-upload"></i>
                </span>
              </span>
              <a className="remove" href="#">
                <i className=" ace-icon fa fa-times"></i>
              </a>
            </label>
            <button type="button" className="btn btn-sm btn-success" onClick={() => handleUpload(answer.id)}>
              Загрузить
						  <i className="ace-icon fa fa-upload icon-on-right bigger-110"></i>
						</button>
            <br />
            <br />
            {url ? ( <img src={url} alt="Uploaded Images" width="100" />) : null}
          </div>
        ) : null}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameEn-' + index}
              placeholder="Ответ (EN)"
              value={nameEn}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameEn')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameEn}</b>
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameRu-' + index}
              placeholder="Ответ (RU)"
              value={nameRu}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameRu')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameRu}</b>
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameUk-' + index}
              placeholder="Ответ (UK)"
              value={nameUk}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameUk')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameUk}</b>
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameIt-' + index}
              placeholder="Ответ (IT)"
              value={nameIt}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameIt')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameIt}</b>
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-namePl-' + index}
              placeholder="Ответ (PL)"
              value={namePl}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'namePl')}
            />
          </div>
        ) : (
          <div>
            <b>{localNamePl}</b>
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameEs-' + index}
              placeholder="Ответ (ES)"
              value={nameEs}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameEs')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameEs}</b>
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-namePt-' + index}
              placeholder="Ответ (PT)"
              value={namePt}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'namePt')}
            />
          </div>
        ) : (
          <div>
            <b>{localNamePt}</b>
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <p>
            <button className="btn btn-success btn-xs" onClick={() => onClickSave(answer.id)}>
              <i className="ace-icon fa fa-save bigger-110 icon-only"></i>
            </button>
            &nbsp;&nbsp;
            <button className="btn btn-grey btn-xs" onClick={() => onClickCancel()}>
              <i className="ace-icon fa fa-reply bigger-110 icon-only"></i>
            </button>
          </p>
        ) : (
          <p>
            <button className="btn btn-warning btn-xs" onClick={() => onClickEdit()}>
              <i className="ace-icon fa fa-pencil-square-o bigger-110 icon-only"></i>
            </button>
            &nbsp;&nbsp;
            <button className="btn btn-grey btn-xs" onClick={() => onClickDelete(answer.id)}>
              <i className="ace-icon fa fa-trash-o bigger-110 icon-only"></i>
            </button>
          </p>
        )}
      </td>
		</tr>
	);
};

export default AnswerItem;
